import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { TopPicks } from "./TopPicks";
import { CrazyDeals } from "./CrazyDeals";
import { Prodforyou } from "./Productsforyou";
import { FaChevronRight } from "react-icons/fa";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

const DealsSection = () => {
  const [topDeals1, setTopDeals1] = useState([]);
  const [topDeals2, setTopDeals2] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAll = async () => {
      try {
        
        const prodRes = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_create_product"
        );

        if (prodRes.data.status === true || prodRes.data.status === "true") {
          const filtered = prodRes.data.data.filter(
            (item) => item.product_status === "Grand Global Brand" &&
                      item.admin_approval === "approval" &&
                      item.paid_approval === "yes"
          );
          setTopDeals1(filtered);
        } else {
          toast.error("Failed to fetch product list!");
        }
      } catch (error) {
        console.error("Error fetching:", error);
        toast.error("Error fetching product list.");
      } finally {
        setLoading(false);
      }
    };

    fetchAll();
  }, []);


  useEffect(() => {
    const fetchAll = async () => {
      try {

        const prodRes = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_create_product"
        );

        if (prodRes.data.status === true || prodRes.data.status === "true") {
          const filtered = prodRes.data.data.filter(
            (item) => item.product_status === "Shop By Category" &&
                      item.admin_approval === "approval" &&
                      item.paid_approval === "yes"
          );
          setTopDeals2(filtered);
        } else {
          toast.error("Failed to fetch product list!");
        }
      } catch (error) {
        console.error("Error fetching:", error);
        toast.error("Error fetching product list.");
      } finally{
        setLoading(false);
      }
    };

    fetchAll();
  }, []);

  return (
    <div className="container py-2 mb-3">
      <div className="row">
        {/* Left Section */}
        <div className="col-12 col-md-6 bg-white mb-3 p-3 rounded shadow-sm left-sec">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h3 className="fw-bold m-0">Grand Global Brand</h3>
            <Link
                        to="/products"
                        state={{ categoryId: 1 }} // 🔥 Electronics ID
                        className="text-decoration-none"
                        style={{ color: "#ff7043" }}
                      >
            <button
              style={{
                backgroundColor: "#ff7043",
                border: "none",
                borderRadius: "50%",
                width: "30px",
                height: "30px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <FaChevronRight size={15} color="white" />
            </button>
            </Link>
          </div>

          <div className="row mb-3">
           <div className="arrivals-grid-layout-grand-shop">

  {topDeals1.map((deal, index) => (
    <Link
      key={index}
      to={`/model/${deal.product_id}`}
      style={{ textDecoration: "none" }}
    >
      <div className="arrivals-item-card">

        <div className="arrivals-visual">
          <img
            src={`https://cyberathon.com/multivendor/${deal.multi_image?.[0]}`}
            alt={deal.product_name}
          />

          {/* <div className="arrivals-new-badge">NEW</div> */}
          {/* <div className="arrivals-fav">♡</div> */}

          <div className="arrivals-add-layer">
            <button className="arrivals-btn-add">QUICK ADD</button>
          </div>
        </div>

        <div className="arrivals-content">
          <h3 className="arrivals-product-title">
            {deal.product_name}
          </h3>

          <div className="arrivals-price-info">
            <span className="arrivals-price-new">
              ₹{deal.current_price}
            </span>
          </div>
        </div>

      </div>
    </Link>
  ))}

</div>
          </div>
        </div>

        {/* Right Section */}
        <div className="col-12 col-md-6 bg-white mb-3 p-3 rounded shadow-sm right-sec">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h3 className="fw-bold m-0">Shop By Category</h3>
            <Link
                        to="/products"
                        state={{ categoryId: 2 }} // 🔥 Electronics ID
                        className="text-decoration-none"
                        style={{ color: "#ff7043" }}
                      >
            <button
              style={{
                backgroundColor: "#ff7043",
                border: "none",
                borderRadius: "50%",
                width: "30px",
                height: "30px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <FaChevronRight size={15} color="white" />
            </button>
            </Link>
          </div>

          <div className="row mb-3">
            <div className="arrivals-grid-layout-grand-shop">

  {topDeals2.map((deal, index) => (
    <Link
      key={index}
      to={`/model/${deal.product_id}`}
      style={{ textDecoration: "none" }}
    >
      <div className="arrivals-item-card">

        <div className="arrivals-visual">
          <img
            src={`https://cyberathon.com/multivendor/${deal.multi_image?.[0]}`}
            alt={deal.product_name}
          />

          {/* <div className="arrivals-new-badge">NEW</div> */}
          {/* <div className="arrivals-fav">♡</div> */}

          <div className="arrivals-add-layer">
            <button className="arrivals-btn-add">QUICK ADD</button>
          </div>
        </div>

        <div className="arrivals-content">
          <h3 className="arrivals-product-title">
            {deal.product_name}
          </h3>

          <div className="arrivals-price-info">
            <span className="arrivals-price-new">
              ₹{deal.current_price}
            </span>
          </div>
        </div>

      </div>
    </Link>
  ))}

</div>
          </div>
        </div>
      </div>

      {/* Other Sections */}
      <TopPicks />
      <CrazyDeals />
      <Prodforyou />
    </div>
  );
};

export default DealsSection;
